import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import "./Loader.scss";

const Loader = ({
  visible = false,
  message = "",
}) => {
  if (!visible) return null;

  return (
    <div className="loader-overlay">
      <ProgressSpinner
        style={{
          width: "80px",
          height: "80px",
        }}
        strokeWidth="4"
        animationDuration=".8s"
      />
      {message && (
        <p
          className="loader-message"
          style={{
            fontFamily: "var(--font-paragraph)",
            fontSize: "var(--paragraph-font-size)",
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default Loader;
